var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 0.75H5.25C2.76825 0.75 0.75 2.76825 0.75 5.25V36.75C0.75 39.2318 2.76825 41.25 5.25 41.25H23.25C23.5455 41.2504 23.8382 41.1924 24.1112 41.0793C24.3842 40.9661 24.6322 40.8001 24.8407 40.5908L40.5908 24.8407C40.7757 24.6489 40.9251 24.4257 41.0317 24.1815C41.0632 24.114 41.0813 24.0443 41.106 23.9723C41.1701 23.784 41.2087 23.588 41.2207 23.3895C41.2252 23.3423 41.25 23.2972 41.25 23.25V5.25C41.25 2.76825 39.2318 0.75 36.75 0.75V0.75ZM5.25 5.25H36.75V21H23.25C22.6533 21 22.081 21.2371 21.659 21.659C21.2371 22.081 21 22.6533 21 23.25V36.75H5.25V5.25ZM25.5 33.5685V25.5H33.5685L25.5 33.5685Z",
    fill: "#00793A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.9e4b3a80.svg";
export { ForwardRef as ReactComponent };